const TagType = {
  Byte: 'byte',
  Short: 'short',
  Int: 'int',
  Long: 'long',
  Float: 'float',
  Double: 'double',
  ByteArray: 'byteArray',
  String: 'string',
  List: 'list',
  Compound: 'compound',
  IntArray: 'intArray',
  LongArray: 'longArray'
}

module.exports = TagType
